import React, { useEffect, useState, useMemo } from 'react';
import {
  Card,
  Col,
  Form,
  Row,
  Alert,
  Table,
  Image,
} from 'react-bootstrap';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import Tooltip from '@mui/material/Tooltip';
import { Link, Element } from 'react-scroll';
import { useHistory, useLocation } from 'react-router-dom';
import {
  makeUID, stepScroll, years,
} from '../../helpers';
import './styling.less';
import UniqueResultCardReadView from './UniqueResultCardReadView';
import ReportStatusBadge from '../ReportStatusBadge';
import ExpertCard from './ExpertCard';
import {
  getExpertCardParams,
} from './UniqueResultsPermsHelper';
import { statusKeys as PS } from '../../helpers/projReportHelper';
import useUserContext from '../../hooks/useUserContext';
import useToast from '../../hooks/useToast';
import useAPI from '../../hooks/useAPI';

import YearSelect from '../common/YearSelect';

import BudgetTableSf from './BudgetTableSf';
import BudgetTableFb from './BudgetTableFb';

import { isAdmin } from '../../services/rolesSvc';
import { floatRenderer, dateRenderer } from '../../services/formatSvc';

import { getActionsModel } from '../../services/roles/projResultReportRoleStatus';
import ButtonsCard from './ButtonsCard';
import ConfirmModal from '../common/ConfirmModal';
import ModalSendForRevision from '../common/ModalSendForRevision';
import ModalUploadReportScan from './ModalUploadReportScan';
import CloseProjCard from "./CloseProjCard";
import {closeProject, editCloseDataProject, editExpertDecision} from "../../requests/ProjectRequest/projectRequest";
import {monthsArray} from "../../stores/StratProject/StrategyStore";
import fileIcon from '../../../img/icons/FileTableIcon.svg';
import MilestoneFilesModal from "../project/PassportRead/MilestoneFilesModal";
import TooltippedElement from "../common/TooltippedElement";
import YearReportIndicators from './YearReportSections/YearReportIndicators';

export default function ReportYearRead({
  projectId,
  permissions,
  role,
  year,
  changeYear,
  stratId,
  title,
  project
}) {
  const filterYears = useMemo(() => [year], [year]);

  const [validated, setValidated] = useState(false);
  const [result, setResult] = useState(null);
  const [proj, setProj] = useState({});
  const [pcVals, setpcVals] = useState([]); // показатели
  const [results, setResults] = useState([]); // уник рез
  const [milestones, setMilestones] = useState([])
  const [selectedMilestone, setSelectedMilestone] = useState(null)
  const [trls, setTrls] = useState([])
  const [plans, setPlans] = useState(null);
  const [finsources, setFinsources] = useState(null);
  const [status, setStatus] = useState(null);
  const [comment, setComment] = useState({});
  const [info, setInfo] = useState({});
  const [names, setNames] = useState({});
  const [letters, setLetters] = useState([]);
  const [names2, setNames2] = useState({});
  const [decision, setDecision] = useState({
    mark:'',
    isApproved: true,
    recommendations: undefined,
    protocol: undefined,
    decisionDate: undefined,
    decisionFiles:[]
  });

  const [closeData,setCloseData] = useState({
    closedOn:undefined,
    closeFiles:[]
  })

  const userCtx = useUserContext();
  const addToast = useToast();
  const history = useHistory();
  const location = useLocation();
  const api = useAPI();

  const can = useMemo(() => getActionsModel(status, userCtx, proj?.strategyId, proj?.originId, proj?.portfId, proj?.policyId, proj?.status), [status, proj]);
  const expertCardParams = useMemo(() => getExpertCardParams(userCtx, status), [status]);

  // #region Modals
  const [isModalSendToPortfVisible, setIsModalSendToPortfVisible] = useState(false);
  const [isModalSendToHeadVisible, setIsModalSendToHeadVisible] = useState(false);
  const [isModalRevisionPortf, setIsModalRevisionPortf] = useState(false);
  const [isModalRevisionHead, setIsModalRevisionHead] = useState(false);
  const [isModalRevisionExpert, setIsModalRevisionExpert] = useState(false);
  const [isModalUpload, setIsModalUpload] = useState(false);
  const [isModalCloseProj, setModalCloseProj] = useState(false);
  const [isMilestoneFilesModal, setIsMilestoneFilesModal] = useState(false)
  // #endregion

  const getFileType = (f) => (f.link ? 'link' : 'file');

  const prepareResults = (results) => {
    const a = results.map((r) => ({
      ...r,
      files: r.files.map((f) => ({
        ...f,
        hash: makeUID(5),
        type: getFileType(f),
      })),
    }));
    // to do
    // name и тд
    const names = [];
    const res = {};
    a.forEach((e) => {
      if (!names.includes(e.title)) {
        names.push(e.title);
        res[e.title] = [e];
      } else {
        res[e.title].push(e);
      }
    });
    return res;
  };

  useEffect(async () => {
    setResult(null);
    setPlans(null);
    setFinsources(null);
    setpcVals([]);
    setProj({});
    setStatus(null);
    setInfo({});
    setResults([]);
    setComment({});
    if (true) {
      const respResults = await api.get(
        `/projs/${projectId}/results?year=${year}`,
      );
      setProj(respResults.proj);
      setStatus(respResults.status);
      setInfo(respResults.info);
      setComment({
        commentPortf: respResults.commentPortf,
        commentHead: respResults.commentHead,
        commentExpert: respResults.commentExpert,
      });
      const respResults2 = await api.get('/mng/finsources');
      const letters = await api.get('/mng/letters');
      const trls = await api.get('/mng/trls');
      setTrls(trls)
      setLetters(letters);
      const finSourcesByKeys = _.keyBy(respResults2, 'type');
      const dataGrouped = _.groupBy(respResults.plans, 'type');
      setResult(respResults);
      dataGrouped?.fb?.sort((a, b) => a.year > b.year);
      dataGrouped?.sf?.sort((a, b) => a.year > b.year);
      setPlans(dataGrouped);
      setFinsources(finSourcesByKeys);

      setpcVals([
        // ...respResults2021.pcVals,
        ...respResults.pcVals,
        // ...respResults2023.pcVals,
      ]);
      handlepcVals([
        // ...respResults2021.pcVals,
        ...respResults.pcVals,
        // ...respResults2023.pcVals,
      ]);
      setResults(
        prepareResults([
          // ...respResults2021.results,
          ...respResults.results,
          // ...respResults2023.results,
        ]),
      );
      const newResponseDecision = {
        isApproved: respResults.status !== PS.expertsDeclined,
        recommendations: respResults.decision ?? '',
        protocol: respResults.protocol ?? '',
        decisionDate: respResults.decisionDate ?? '',
        mark: respResults.mark ?? '',
        decisionFiles:respResults.decisionFiles
      };
      setDecision(newResponseDecision);
      const newCloseData = {
        closedOn:respResults.proj.closedOn,
        closeFiles:respResults.proj.decisionFiles
      }
      setCloseData(newCloseData)
      setMilestones(respResults.milestones)
    }
  }, [year]);

  const handleResultChange = (id, field, newValue) => {
    if (field === 'isKey') {
      setResults((prevResults) =>
        prevResults.map((r) =>
          (r.id === id ? { ...r, isKey: newValue } : { ...r, isKey: false })));
    } else {
      setResults((prevResults) =>
        prevResults.map((r) => (r.id === id ? { ...r, [field]: newValue } : r)));
    }
  };

  function handlepcVals(arr) {
    const names = [];
    const res = {};
    arr.forEach((e) => {
      if (!names.includes(e.name)) {
        names.push(e.name);
        res[e.name] = [];
        const obj = e;
        obj.year = e.values.year;
        obj.plan = e.values.plan;
        obj.fact = e.values.fact;
        res[e.name].push(obj);
      } else {
        const obj = e;
        obj.year = e.values.year;
        obj.plan = e.values.plan;
        obj.fact = e.values.fact;
        res[e.name].push(obj);
      }
    });
    setNames(res);
  }

  const saveFormData = async () => {
    const resultsToSubmit = results.map((r) => ({
      id: r.id,
      descr: r.descr,
      fact: r.fact,
      isKey: r.isKey,
      year: r.year,
    }));

    const filesToSubmit = results.reduce((acc, res) => {
      const filesToAdd = res.files
        .filter(
          (f) =>
            !f.id
            && ((f.type === 'link' && f.link) || (f.type === 'file' && f.file)),
        )
        .map((f) => ({
          resultId: res.id,
          hash: f.hash,
          title: f.title,
          link: f.type === 'link' ? f.link : null, // todo
          file: f.type === 'file' ? f.file : null,
          type: f.type,
        }));
      return [...acc, ...filesToAdd];
    }, []);

    if (filesToSubmit.some((f) => !f.title)) {
      addToast.error(
        'Укажите название документа и попробуйте снова сохранить отчет',
      );
      return false;
    }

    const respResults = await api.post(`/projs/${projectId}/results`, {
      year,
      info,
      facts: resultsToSubmit,
    });
    if (respResults.error) {
      return false;
    }

    for (const file of filesToSubmit) {
      switch (file.type) {
        case 'link':
          const linkResults = await api.post(
            `/projs/${projectId}/results/${file.resultId}/files`,
            { title: file.title, link: file.link },
          );
          if (!linkResults || linkResults.error) {
            addToast.error(
              `При сохранении документа "${file.title}" произошла ошибка`,
            );
            return false;
          }
          await setResults((prevState) =>
            prevState.map((r) =>
              (r.id === file.resultId
                ? {
                  ...r,
                  files: r.files.map((f) =>
                    (f.hash === file.hash ? { ...f, ...linkResults } : f)),
                }
                : r)));
          break;
        case 'file':
          const fileResults = await api.postFormData(
            `/projs/${projectId}/results/${file.resultId}/files`,
            { title: file.title },
            file.file,
              {isJsonValue:true}
          );
          if (!fileResults || fileResults.error) {
            addToast.error(
              `При сохранении документа "${file.title}" произошла ошибка`,
            );
            return false;
          }
          await setResults((prevState) =>
            prevState.map((r) =>
              (r.id === file.resultId
                ? {
                  ...r,
                  files: r.files.map((f) =>
                    (f.hash === file.hash ? { ...f, ...fileResults } : f)),
                }
                : r)));
          break;
      }
    }
    return true;
  };

  const handleCloseProj = () => {
    const projIds = [projectId]
    const saveOrEditPromise = !!proj?.closedOn
        ? editCloseDataProject(addToast,{projId:projectId,...closeData})
        : closeProject(addToast,{projIds,...closeData})
    return saveOrEditPromise
        .then(response=> setCloseData({
            closedOn: response.closedOn,
            closeFiles: response.decisionFiles
          }))
        .finally(()=>setModalCloseProj(!isModalCloseProj))
  }

  if (!permissions.canRead) {
    return (
      <div style={{ color: 'red', background: 'white' }}>
        Недостаточно прав для просмотра страницы
      </div>
    );
  }

  // #region Actions
  const actions = {
    onEdit: () => history.push({
      pathname:`${location.pathname}`,
      search:`?edit=1`
    }),
    onSendPortf: () => setIsModalSendToPortfVisible(true),
    onSendHeadSP: () => setIsModalSendToHeadVisible(true),
    onSendExperts: () => handleSendExperts(),
    onReturnForRevisionPortf: () => setIsModalRevisionPortf(true),
    onReturnForRevisionHead: () => setIsModalRevisionHead(true),
    onReturnForRevisionExpert: () => setIsModalRevisionExpert(true),
    onApproveExpert: () => handleExpertApprove(),
    onApproveFinal: () => setIsModalUpload(true),
  };
  const apiSendPortf = async () => {
    const response = await api.post(`/projs/${proj.id}/results/0/sendToPortf`, { year });
    if (!response.error && response.status) {
      setStatus(response.status);
      setIsModalSendToPortfVisible(false);
      addToast.success('Успешно отправлен руководителю портфеля на согласование');
      window.scroll({ top: 0, left: 0, behavior: 'smooth' });
    }
  };
  const apiSendHeadSP = async () => {
    const response = await api.post(`/projs/${proj.id}/results/0/sendToHead`, { year });
    if (!response.error && response.status) {
      setStatus(response.status);
      setIsModalSendToHeadVisible(false);
      addToast.success('Успешно отправлен руководителю СП на согласование');
      window.scroll({ top: 0, left: 0, behavior: 'smooth' });
    }
  };
  const handleSendExperts = async () => {
    const response = await api.post(`/projs/${proj.id}/results/0/sendToExperts`, { year });
    if (!response.error && response.status) {
      setStatus(response.status);
      addToast.success('Успешно отправлен секретарю Экспертной группы');
      window.scroll({ top: 0, left: 0, behavior: 'smooth' });
    }
  };

  const apiReturnForRevision = async (comment) => {
    const response = await api.post(`/projs/${proj.id}/results/0/return`, { year, comment });
    if (!response.error) {
      setIsModalRevisionPortf(false);
      setIsModalRevisionHead(false);
      setIsModalRevisionExpert(false);

      setComment((prev) => ({ ...prev, ...response.comment }));
      setStatus(response.status);

      window.scroll({ top: 0, left: 0, behavior: 'smooth' });
    }
  };

  const apiReturnForRevisionPortf = apiReturnForRevision;
  const apiReturnForRevisionHead = apiReturnForRevision;
  const apiReturnForRevisionExpert = apiReturnForRevision;

  const handleExpertApprove = async () => { // одобрить от лица РСП для портфельных проектов
    const response = await api.post(`/projs/${proj.id}/results/0/expertApprove`, { year });
    if (!response.error && response.status) {
      setComment({});
      setStatus(response.status);
      setDecision((prev) => ({ ...prev, decisionDate: response.decisionDate }));
      addToast.success('Успешно одобрен');
      window.scroll({ top: 0, left: 0, behavior: 'smooth' });
    }
  };

  const handleSubmitGroupDecision = async () => {
    const decisionDTO = {
      isApproved: decision.isApproved,
      decision: decision.recommendations,
      protocol: decision.protocol,
      decisionDate:decision.decisionDate,
      mark:decision.mark,
      // decisionFiles:decision.decisionFiles
    };
    let decisionResponse = await api.postFormData(`/projs/${proj.id}/results/0/decide`, { year, ...decisionDTO }, decision.decisionFiles);
    decisionResponse = Array.isArray(decisionResponse) ? decisionResponse[0] : decisionResponse
    if (decisionResponse.error) return;
    setDecision({
      isApproved: decisionResponse.isApproved,
      recommendations: decisionResponse.decision,
      protocol: decisionResponse.protocol,
      decisionDate: decisionResponse.decisionDate,
      mark:decisionResponse.mark,
      decisionFiles:decision.decisionFiles
    });
    setStatus(decisionResponse.status);
    setComment({});
    addToast.info('Решение Экспертной группы сохранено');
  };

  const handleEditGroupDecision = async () => {
    const decisionDTO = {
      recommendations: decision.recommendations,
      protocol: decision.protocol,
      decisionDate: decision.decisionDate,
      mark:decision.mark,
      isApproved:decision.isApproved,
      decisionFiles: decision.decisionFiles
    };
    const decisionResponse = await editExpertDecision(addToast, { year, ...decisionDTO }, projectId);
    if (decisionResponse.error) return;
    setDecision((prev) => ({
      ...prev,
      recommendations: decisionResponse.decision,
      protocol: decisionResponse.protocol,
      decisionDate: decisionResponse.decisionDate,
      mark:decisionResponse.mark,
      isApproved:decisionResponse.status !== PS.expertsDeclined,
      decisionFiles:decisionResponse.decisionFiles
    }));
    // addToast.info('Рекомендации/реквизиты протокола сохранены');
  };

  const handleDecisionChange = (fieldName, value) => setDecision((prev) => ({ ...prev, [fieldName]: value }));

  const handleCloseDataChange = (fieldName, value) => setCloseData((prev) => ({ ...prev, [fieldName]: value }));

  const uploadScan = async (file, approvedOn) => {
    const response = await api.postFormData(
      `/projs/${projectId}/results/0/uploadScan`,
      { year, approvedOn },
      file,
        {isJsonValue:false}
    );

    if (response && !response.error) {
      setResult((prev) => ({ ...prev, minioScanFile: response.minioScanFile, approvedOn: response.approvedOn }));
      setStatus(response.status);
      addToast.success(file ? 'Скан успешно загружен' : 'Данные успешно обновлены');
      return true;
    }
    addToast.error('При загрузке скана произошла ошибка');
    return false;
  };
  // #endregion

  return (
    <section className="page unique-results" style={{ background: 'transparent' }}>
      <nav className="step-scroll-box" style={{ marginBottom: '44px' }}>
        <Link to="Contents" {...stepScroll}>
          Содержание
        </Link>
        <Link to="Results" {...stepScroll}>
          Основные результаты
        </Link>
        <Link to="UniqueResults" {...stepScroll}>
          Уникальные результаты
        </Link>
        <Link to="Milestones" {...stepScroll}>
          Вехи проекта
        </Link>
        <Link to="Indicators" {...stepScroll}>
          Показатели
        </Link>
        <Link to="Achievements" {...stepScroll}>
          Достигнутые эффекты от реализации
        </Link>
        <Link to="Budget" {...stepScroll}>
          Бюджет
        </Link>
        <Link to="Decision" {...stepScroll}>
          Решение ЭГ
        </Link>
      </nav>
      <h3 style={styledHeading}>{`Ежегодный отчёт по проекту ${title}`}</h3>
      <div style={styledContainer}>
        <div style={styledCheckerContainer}>
          <div className="year-checkboxes">
            <YearSelect
              year={year}
              years={years}
              onChange={(e) => changeYear(e.value)}
            />
          </div>
        </div>
        <div>
          <ReportStatusBadge status={status} />
        </div>
      </div>

      { comment?.commentPortf && (
      <Alert variant="danger" style={{ whiteSpace: 'pre-wrap' }}>
        <strong>Комментарий руководителя портфеля</strong>
        <br />
        <br />
        {comment?.commentPortf}
      </Alert>
      ) }
      { comment?.commentHead && (
      <Alert variant="danger" style={{ whiteSpace: 'pre-wrap' }}>
        <strong>Комментарий руководителя СП</strong>
        <br />
        <br />
        {comment?.commentHead}
      </Alert>
      ) }
      { comment?.commentExpert && (
      <Alert variant="danger" style={{ whiteSpace: 'pre-wrap' }}>
        <strong>Комментарий Проектного офиса</strong>
        <br />
        <br />
        {comment?.commentExpert}
      </Alert>
      ) }

      <Form noValidate validated={validated} style={{ background: '#F5F5FF' }}>
        {result && (
          <>
            <Element id="Contents" name="Contents">
              <Card className="mb-4">
                <Card.Header className="p-4">Содержание</Card.Header>
                <Card.Body className="p-4">
                  <Row className="mb-4">
                    <Col md={6}>
                      <Card.Subtitle style={styledLabel} className="mb-2">
                        Дата утверждения отчета
                      </Card.Subtitle>
                      <Card.Text>
                        {result?.approvedOn
                          ? dateRenderer(result?.approvedOn)
                          : ''}
                      </Card.Text>
                    </Col>
                  </Row>
                  <Row className="mb-4">
                    <Col md={6}>
                      <Card.Subtitle
                        style={styledLabel}
                        className="mb-2 text-muted"
                      >
                        Тематика проекта
                      </Card.Subtitle>
                      <Card.Text>{info?.theme}</Card.Text>
                    </Col>
                  </Row>
                  <h4
                    style={{
                      marginBottom: '24px',
                      fontSize: '18px',
                      textAlign: 'left',
                    }}
                  >
                    Цель
                  </h4>
                  <Row className="mb-4">
                    <Col md={12}>
                      <Card.Text>{proj?.goal}</Card.Text>
                    </Col>
                  </Row>
                  <h4
                    style={{
                      marginBottom: '24px',
                      fontSize: '18px',
                      textAlign: 'left',
                    }}
                  >
                    Задачи
                  </h4>
                  <Row className="mb-4">
                    <Col md={12}>
                      <Card.Text>{proj?.tasks}</Card.Text>
                    </Col>
                  </Row>
                  <Row className="mb-4">
                    {proj?.typeId === 3 && (
                      <Col md={6}>
                        <Card.Subtitle
                          style={styledLabel}
                          className="mb-2 text-muted"
                        >
                          Регистрационный номер НИОКР
                          <Tooltip
                            title="Регистрационный номер НИОКР, присвоенный в системе ЕГИСУ НИОКТР"
                            placement="top-end"
                          >
                            <HelpOutlineIcon />
                          </Tooltip>
                        </Card.Subtitle>
                        <Card.Text>{info?.regNumber}</Card.Text>
                      </Col>
                    )}
                    <Col md={6}>
                      <Card.Subtitle
                        style={styledLabel}
                        className="mb-2 text-muted"
                      >
                        Ссылка на связанную работу
                      </Card.Subtitle>
                      <Card.Text>{info?.linkedWork}</Card.Text>
                    </Col>
                  </Row>
                  <Row className="mb-4">
                    <Col md={12}>
                      <Card.Subtitle
                        style={styledLabel}
                        className="mb-2 text-muted"
                      >
                        Описание
                      </Card.Subtitle>
                      <Card.Text>{proj?.descr}</Card.Text>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            </Element>

            <Element id="Results" name="Results">
              <Card className="mb-4">
                <Card.Header className="p-4">
                  Основные достигнутые результаты и проблемы, выявленные при реализации проекта в отчетном периоде
                </Card.Header>
                <Card.Body className="p-4">
                  <Row className="mb-4">
                    <Col md={12}>
                      <Card.Subtitle
                        style={styledLabel}
                        className="mb-2 text-muted"
                      >
                        План
                      </Card.Subtitle>
                      <Card.Text>{proj?.result}</Card.Text>
                    </Col>
                  </Row>
                  {proj?.portfId ? (
                    <>
                      <Row className="mb-4">
                        <Col md={12}>
                          <Card.Subtitle
                            style={styledLabel}
                            className="mb-2 text-muted"
                          >
                            Фактически достигнутые научные результаты
                          </Card.Subtitle>
                          <Card.Text>{info?.resultSciFact}</Card.Text>
                        </Col>
                      </Row>
                      {proj?.hasSciOrgResults && (
                        <Row className="mb-4">
                          <Col md={12}>
                            <Card.Subtitle
                              style={styledLabel}
                              className="mb-2 text-muted"
                            >
                              Фактически достигнутые организационные результаты
                            </Card.Subtitle>
                            <Card.Text>{info?.resultOrgFact}</Card.Text>
                          </Col>
                        </Row>
                      )}
                    </>
                  ) : (
                    <Row className="mb-4">
                      <Col md={12}>
                        <Card.Subtitle
                          style={styledLabel}
                          className="mb-2 text-muted"
                        >
                          Факт
                        </Card.Subtitle>
                        <Card.Text>{info?.resultFact}</Card.Text>
                      </Col>
                    </Row>
                  )}
                  <Row className="mb-4">
                    <Col md={12}>
                      <Card.Subtitle
                        style={styledLabel}
                        className="mb-2 text-muted"
                      >
                        Проблемы, выявленные при реализации проекта
                      </Card.Subtitle>
                      <Card.Text>{info?.problems}</Card.Text>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            </Element>

            <Element id="UniqueResults" name="UniqueResults">
              <Card className="mb-4">
                <Card.Header className="p-4">
                  Уникальные результаты проекта
                </Card.Header>
                <Card.Body className="p-4">
                  <div
                    style={{
                      overflowX: 'scroll',
                      overflowY: 'scroll',
                      maxHeight: '75vh',
                    }}
                  >
                    <Table striped className="read-view">
                      <thead>
                        <tr>
                          <th
                            style={{
                              position: 'sticky',
                              top: '0',
                              zIndex: '1',
                              background: 'white',
                              minWidth: '250px',
                            }}
                          >
                            Название (план)
                          </th>
                          <th
                            style={{
                              position: 'sticky',
                              top: '0',
                              zIndex: '1',
                              background: 'white',
                              minWidth: '250px',
                            }}
                          >
                            Описание (факт)
                          </th>
                          <th
                            style={{
                              position: 'sticky',
                              top: '0',
                              zIndex: '1',
                              background: 'white',
                            }}
                          >
                            Единицы измерения
                          </th>
                          {filterYears.map((e) => (
                            <>
                              <th
                                style={{
                                  position: 'sticky',
                                  top: '0',
                                  zIndex: '1',
                                  background: 'white',
                                }}
                              >
                                Значение (план) (
                                {e}
                                )
                              </th>
                              <th
                                style={{
                                  position: 'sticky',
                                  top: '0',
                                  zIndex: '1',
                                  background: 'white',
                                }}
                              >
                                Значение (факт) (
                                {e}
                                )
                              </th>
                            </>
                          ))}
                          <th
                            style={{
                              position: 'sticky',
                              top: '0',
                              zIndex: '1',
                              background: 'white',
                            }}
                          >
                            % выполнения
                          </th>
                          <th
                            style={{
                              position: 'sticky',
                              top: '0',
                              zIndex: '1',
                              background: 'white',
                              minWidth: '250px',
                            }}
                          >
                            Мероприятие
                          </th>
                          <th
                            style={{
                              position: 'sticky',
                              top: '0',
                              zIndex: '1',
                              background: 'white',
                              minWidth: '250px',
                            }}
                          >
                            Тип
                          </th>
                          <th
                            style={{
                              position: 'sticky',
                              top: '0',
                              zIndex: '1',
                              background: 'white',
                            }}
                          >
                            Ключевой
                          </th>
                          <th
                            style={{
                              position: 'sticky',
                              top: '0',
                              zIndex: '1',
                              background: 'white',
                            }}
                          >
                            Документы
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {Object.keys(results).map((p) => (
                          <tr key={p[0].id}>
                            <td>{p}</td>
                            <td>{results[p][0].descr}</td>
                            <td>{results[p][0].unit}</td>
                            {filterYears.map((year) => (
                              <>
                                <td>
                                  {
                                    results[p].filter((e) => e?.year == year)[0]
                                      ?.value
                                  }
                                </td>
                                <td>
                                  {
                                    results[p].filter((e) => e.year == year)[0]
                                      ?.fact
                                  }
                                </td>
                              </>
                            ))}

                            <td>
                              {`${floatRenderer(
                                (results[p].filter((e) => e.year == year)[0]
                                  ?.fact
                                  / results[p].filter((e) => e?.year == year)[0]
                                    ?.value)
                                  * 100,
                              )}%`}
                            </td>
                            <td>
                              {results[p][0]?.letterCode}
                              {' '}
                              {letters?.filter(
                                (e) => e?.code === results[p][0]?.letterCode,
                              )[0]?.descr || ''}
                            </td>
                            <td>{results[p][0].type.name}</td>
                            <td>{results[p][0].isKey ? 'Да' : 'Нет'}</td>
                            <td>
                              <UniqueResultCardReadView
                                data={results[p]} // to do
                                onResultChange={handleResultChange}
                              />
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </div>
                </Card.Body>
              </Card>
            </Element>

            <Element id="Milestones" name="Milestones">
              <Card className='mb-4'>
                <Card.Header className="p-4">Вехи проекта</Card.Header>
                <Card.Body>
                  <Table striped className='read-view'>
                    <thead>
                      <th>Веха</th>
                      <th>Достижение</th>
                      <th>Дата вып. (план)</th>
                      <th>Дата вып. (факт)</th>
                      <th>УГТ (план)</th>
                      <th>УГТ (факт)</th>
                      <th>Ответственный</th>
                      <th>Док.</th>
                    </thead>
                    <tbody>
                    {milestones.sort((a, b) => a.yearPlan - b.yearPlan || a.monthPlan - b.monthPlan).map((milestone) => <tr>
                      <td>{milestone.name}</td>
                      <td>{milestone.result || '-'}</td>
                      <td>{monthsArray[milestone.monthPlan - 1]}, {milestone.yearPlan}</td>
                      <td>{milestone.monthFact ? `${monthsArray[milestone.monthFact - 1]}, ${milestone.yearFact}` : '-'}</td>
                      <td>
                        {milestone.trl?.id ? <TooltippedElement iconSize={'16px'}
                                            tooltip={trls.find((trl) => trl.id === milestone.trl?.id)?.descr}>{milestone.trl?.id}</TooltippedElement> : '-'}
                      </td>
                      <td>
                        {milestone.trlFactId ? <TooltippedElement iconSize={'16px'}
                                            tooltip={trls.find((trl) => trl.id === milestone.trlFactId)?.descr}>{milestone.trlFactId}</TooltippedElement> : '-'}
                      </td>
                      <td>{milestone.personsInCharge?.length > 0 ? `${getName(milestone.personsInCharge[0].displayName)}, ${milestone.personsInCharge[0].post}` : ''}</td>
                      <td style={{minWidth: 70}}>
                        <div className='d-flex align-items-center gap-1' style={{color: '#0D6EFD', cursor: 'pointer'}} onClick={() => {
                          setSelectedMilestone(milestone)
                          setIsMilestoneFilesModal(true)
                        }}>
                          <Image src={fileIcon} style={{width: 16}}/>
                          {milestone.files?.length ?? 0}
                        </div>
                      </td>
                    </tr>)}
                    </tbody>
                  </Table>
                </Card.Body>
              </Card>
            </Element>

            <Element id="Indicators" name="Indicators">
              <YearReportIndicators
                indicators={
                  !!proj?.portfId || proj?.portfId === 0 ?
                    { fixedPcs: pcVals } :
                    {
                      fixedPcs: pcVals.filter(p => p.fixedPcId),
                      pcs: pcVals.filter(p => !p.fixedPcId || p.fixedPcId === 0)
                    }
                }
                filterYears={filterYears}/>
            </Element>

            <Element id="Achievements" name="Achievements">
              <Card className="mb-4">
                <Card.Header className="p-4">
                  Достигнутые эффекты от реализации проекта
                </Card.Header>
                <Card.Body className="p-4">
                  <Row className="mb-4">
                    <Card.Subtitle
                      style={styledLabel}
                      className="mb-2 text-muted"
                    >
                      Эффект на университетском уровне
                    </Card.Subtitle>
                    <Card.Text style={{ whiteSpace: 'pre-wrap' }}>
                      {info?.uniEffect}
                    </Card.Text>
                  </Row>
                  <Row className="mb-4">
                    <Card.Subtitle
                      style={styledLabel}
                      className="mb-2 text-muted"
                    >
                      Эффект на региональном и(или) отраслевом уровне
                    </Card.Subtitle>
                    <Card.Text style={{ whiteSpace: 'pre-wrap' }}>
                      {info?.regionEffect}
                    </Card.Text>
                  </Row>
                  <Row className="mb-4">
                    <Card.Subtitle
                      style={styledLabel}
                      className="mb-2 text-muted"
                    >
                      Эффект на национальном уровне
                    </Card.Subtitle>
                    <Card.Text style={{ whiteSpace: 'pre-wrap' }}>
                      {info?.countryEffect}
                    </Card.Text>
                  </Row>
                </Card.Body>
              </Card>
            </Element>

            <Element id="Budget" name="Budget">
              <Card className="mb-4">
                <Card.Header className="p-4">Бюджет</Card.Header>
                {finsources && plans && (
                  <Card.Body className="p-4">
                    {filterYears.map((y, i) => {
                      if (
                        plans?.fb?.filter((e) => e.year == y).length == 0
                        && plans?.sf?.filter((e) => e.year == y).length == 0
                      ) return;
                      return (
                        <>
                          <div
                            style={{
                              fontSize: '20px',
                              marginBottom: '24px',
                              fontWeight: '600',
                              color: '#212529',
                            }}
                          >
                            {y}
                          </div>
                          <Row className="mb-4">
                            <Card.Subtitle
                              style={styledLabel}
                              className="mb-2 text-muted"
                            >
                              Грант
                            </Card.Subtitle>
                            <BudgetTableFb
                              data={
                                plans?.fb?.filter((e) => e.year == y) || []
                              }
                              finSource={finsources.fb}
                              strategyType={project?.strategy?.type}
                            />
                          </Row>
                          <Row className="mb-4">
                            <Card.Subtitle
                              style={styledLabel}
                              className="mb-2 text-muted"
                            >
                              Софинансирование
                            </Card.Subtitle>
                            <BudgetTableSf
                              data={
                                plans?.sf?.filter((e) => e.year == y) || []
                              }
                              finSource={finsources.sf}
                            />
                          </Row>
                          <Table
                            className="read-view"
                            style={{ tableLayout: 'fixed' }}
                          >
                            <thead>
                              <tr>
                                <th style={{ border: 'none' }} />
                                <th style={{ border: 'none' }} />
                                <th style={{ border: 'none' }} />
                                <th style={{ border: 'none' }} />
                                <th style={{ border: 'none' }} />
                              </tr>
                            </thead>
                            <tbody>
                              <td>Итого за год:</td>
                              <td />
                              <td />
                              <td>
                                <b>
                                  {floatRenderer(
                                    result?.plans?.reduce((prev, d) => {
                                      if (d.year === y) return prev + d.sum;
                                      return prev;
                                    }, 0),
                                  )}
                                </b>
                              </td>
                              <td>
                                <b>
                                  {floatRenderer(
                                    result?.plans?.reduce((prev, d) => {
                                      if (d.year === y) return prev + d.paymentSum;
                                      return prev;
                                    }, 0),
                                  )}
                                </b>
                              </td>
                            </tbody>
                          </Table>
                        </>
                      );
                    })}

                    <Table
                      className="read-view"
                      style={{ tableLayout: 'fixed' }}
                    >
                      <thead>
                        <tr>
                          <th style={{ border: 'none' }} />
                          <th style={{ border: 'none' }} />
                          <th style={{ border: 'none' }} />
                          <th style={{ border: 'none' }} />
                          <th style={{ border: 'none' }} />
                        </tr>
                      </thead>
                      <tbody>
                        <td style={{ fontWeight: '700' }}>
                          Итого за все периоды реализации:
                        </td>
                        <td />
                        <td />
                        <td>
                          <b>
                            {floatRenderer(
                              result?.plans?.reduce((prev, d) => prev + d.sum, 0),
                            )}
                          </b>
                        </td>
                        <td>
                          <b>
                            {floatRenderer(
                              result?.plans?.reduce((prev, d) => prev + d.paymentSum, 0),
                            )}
                          </b>
                        </td>
                      </tbody>
                    </Table>
                  </Card.Body>
                )}
              </Card>
            </Element>
          </>
        )}
        {can.SeeExpertsApproved
          && (<Element id="Decision" name="decision">
                <ExpertCard
                    status={status}
                  className="mb-4"
                  decision={decision}
                  onDecisionChange={handleDecisionChange}
                  onSubmit={handleSubmitGroupDecision}
                  onEdit={handleEditGroupDecision}
                  readOnly={expertCardParams.readOnly}
                  canEdit={expertCardParams.canEdit}
                />
                </Element>
          )}
        {can.CloseProj && (
        <CloseProjCard closeProjValue={closeData} status={proj?.status} onCloseProj={()=>setModalCloseProj(!isModalCloseProj)} onCloseDataChange={handleCloseDataChange}/>
        )}
        <ButtonsCard
          can={can}
          projId={proj?.id}
          originId={proj?.originId}
          status={status}
          actions={actions}
          year={year}
          projNumber={proj?.fullNumber}
        />
        {['expertsApproved', 'approved'].includes(status) && !can.CloseProj && <span style={{ color: "red" }}>Для закрытия проекта необходимо согласовать или отклонить Цифровой паспорт проекта</span>}
      </Form>

      <ConfirmModal
        show={isModalSendToPortfVisible}
        onClose={() => setIsModalSendToHeadVisible(false)}
        onConfirm={apiSendPortf}
        headerText="Отправка отчета"
        message="Отчет будет сохранен и направлен руководителю портфеля, убедитесь, что поля заполнены верно. Отменить действие будет нельзя"
      />
      <ConfirmModal
        show={isModalSendToHeadVisible}
        onClose={() => setIsModalSendToHeadVisible(false)}
        onConfirm={apiSendHeadSP}
        headerText="Отправка отчета"
        message="Проект будет сохранен и направлен руководителю СП, убедитесь, что поля заполнены верно. Отменить действие будет нельзя"
      />
      <ModalSendForRevision
        show={isModalRevisionPortf}
        onSubmit={apiReturnForRevisionPortf}
        onClose={() => setIsModalRevisionPortf(false)}
        headerText="Возврат на доработку"
        label="Комментарий руководителя портфеля"
      />
      <ModalSendForRevision
        show={isModalRevisionHead}
        onSubmit={apiReturnForRevisionHead}
        onClose={() => setIsModalRevisionHead(false)}
        headerText="Возврат на доработку"
        label="Комментарий руководителя СП"
      />
      <ModalSendForRevision
        show={isModalRevisionExpert}
        onSubmit={apiReturnForRevisionExpert}
        onClose={() => setIsModalRevisionExpert(false)}
        headerText="Возврат на доработку"
        label="Комментарий Проектного офиса"
      />
      <ModalUploadReportScan
        status={status}
        title="Загрузить подписанный скан отчета по проекту"
        show={isModalUpload}
        onShow={() => setIsModalUpload(true)}
        onClose={() => setIsModalUpload(false)}
        onSave={uploadScan}
        scanFile={result?.minioScanFile}
        readonly={!can.ApproveFinal}
        canEditDate={isAdmin(userCtx)}
        approvedOn={result?.approvedOn}
      />
      <ConfirmModal
          show={isModalCloseProj}
          onClose={() => setModalCloseProj(false)}
          onConfirm={()=>handleCloseProj()}
          headerText="Закрытие проекта"
          message="Вы уверены, что хотите закрыть проект? Отменить действие будет нельзя"
      />
      <MilestoneFilesModal files={selectedMilestone?.files ?? []} show={isMilestoneFilesModal} onHide={() => setIsMilestoneFilesModal(false)}/>
    </section>
  );
}

const styledContainer = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginBottom: '18px',
};
const styledCheckerContainer = {
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
};
const cardHeaderColor = '#F7F7F7';
const styledHeading = { marginBottom: 34, textAlign: 'left' };
const styledLabel = { color: '#7F7F7F', fontWeight: '600' };
const getName = (name) => {
  const splitted = name.split(' ')
  return `${splitted[0]} ${splitted[1][0]}. ${splitted[2][0]}.`
}
